import { createTheme } from '@mantine/core';

/** Inspired by Mantine Boards DashVista — soft cards, generous radius, clear hierarchy. */
export const adminTheme = createTheme({
    primaryColor: 'violet',
    defaultRadius: 'md',
    fontFamily:
        'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    headings: {
        fontFamily:
            'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        fontWeight: '600',
    },
    components: {
        AppShell: {
            styles: {
                navbar: {
                    borderRight: '1px solid var(--mantine-color-default-border)',
                },
                header: {
                    borderBottom: '1px solid var(--mantine-color-default-border)',
                },
                main: {
                    background: 'var(--mantine-color-body)',
                },
            },
        },
        Card: {
            defaultProps: {
                radius: 'lg',
                withBorder: true,
            },
        },
        Paper: {
            defaultProps: {
                radius: 'lg',
                withBorder: true,
            },
        },
        NavLink: {
            defaultProps: {
                variant: 'subtle',
                radius: 'md',
            },
        },
        Table: {
            defaultProps: {
                striped: true,
                highlightOnHover: true,
                verticalSpacing: 'sm',
            },
        },
    },
});
